import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Per-block error boundary so one broken block never blanks its section/page. Mirrors SectionErrorBoundary
 * — including the `<Suspense>` inside it, which is what actually contains a SERVER-side throw (React 18's
 * Fizz never calls `getDerivedStateFromError`; see the long note in SectionErrorBoundary).
 */
import { t } from '@aquilixshop/i18n';
import { Component, Suspense } from 'react';
export class BlockErrorBoundary extends Component {
    state = { hasError: false };
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    render() {
        if (!this.state.hasError)
            return _jsx(Suspense, { fallback: null, children: this.props.children });
        if (this.props.mode === 'live')
            return null;
        return (_jsx("div", { "data-aqx-block-error": "", style: {
                paddingBlock: 'var(--aqx-sp-3)',
                paddingInline: 'var(--aqx-sp-4)',
                border: '1px dashed var(--aqx-danger)',
                borderRadius: 'var(--aqx-r-md)',
                color: 'var(--aqx-danger)',
                fontFamily: 'var(--aqx-font-sans)',
                fontSize: 'var(--aqx-text-sm)',
            }, children: t(null, 'error.block_failed') }));
    }
}
//# sourceMappingURL=BlockErrorBoundary.js.map